import React from "react";
import { ResponsiveBar } from "@nivo/bar";

import { useCompanyDash } from "hooks/companiesDash";
import { useColorMode } from "@chakra-ui/react";

import Loading from "components/Loading/Loading";

import {
  themeDark,
  themeLight,
  axisBottom,
  axisLeft,
  labelTextColor,
  tooltip,
} from "variables/nivo/default";
import { margin } from "variables/nivo/bar";
import { defaultColors } from "variables/colors";
import { useUnits } from "../../../../hooks/units";
import { useExamDash } from "hooks/examDash";
import { queryGetCheckUpKitsLithium } from "hooks/examDash";
import { filter } from "lodash";
import { useFilter } from "hooks/dashFilter";

const dataMock = [
  {
    label: "Subdosagem",
    count: 10,
  },
  {
    label: "Normal",
    count: 20,
  },
  {
    label: "Intoxicação",
    count: 6,
  },
];

const LithiumValuesChart = () => {
  const {filters} = useFilter();
  const [query] = queryGetCheckUpKitsLithium(() => {}, filters);
  const { isLoading, data } = query;

  const { colorMode } = useColorMode();

  const colorBy = (value) => {
    switch (value) {
      case "Normal":
        return "#E0A51B";
      case "Subdosagem":
        return "#22b357";
      case "1.2-1.5":
        return "#BABABA";
      case "Intoxicação":
        return "#CB4333";
      default:
        break;
    }
  };

  if (isLoading) return <Loading />;

  return (
    <ResponsiveBar
      data={data.data}
      indexBy="label"
      keys={["qntt"]}
      margin={margin}
      groupMode="stacked"
      padding={0.7}
      colors={["#E0A51B", "#22b357", "#BABABA", "#CB4333"]}
      labelSkipHeight={11}
      theme={colorMode === "light" ? themeLight : themeDark}
      axisBottom={axisBottom}
      axisLeft={axisLeft}
      labelTextColor={labelTextColor}
      tooltip={({ indexValue, value }) => tooltip(indexValue, value)}
      colorBy={({ indexValue }) => colorBy(indexValue)}
    />
  );
};

export default LithiumValuesChart;
